import React, { useEffect, useState } from "react";

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");

  // Detect scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      const sections = document.querySelectorAll("section");
      sections.forEach((sec) => {
        const top = window.scrollY;
        const offset = sec.offsetTop - 100;
        const height = sec.offsetHeight;
        const id = sec.getAttribute("id");

        if (top >= offset && top < offset + height) {
          setActive(id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar custom-navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="container nav-container">
        
        {/* BRAND */}
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navbar-menu"
          >
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <a className="navbar-brand" href="#page-top">
            SPVV Innovations 😎
          </a>
        </div>

        {/* MENU */}
        <div className="collapse navbar-collapse" id="navbar-menu">
          <ul className="nav navbar-nav nav-menu">
            {[
              "features",
              "about",
              "services",
              "portfolio",
              "deliveries",
              "testimonials",
              "team",
              "contact",
            ].map((item) => (
              <li key={item}>
                <a
                  href={`#${item}`}
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </nav>
  );
};